import { ConfirmationModal } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { RichTextViewerWithFetch } from "./RichTextViewerWithFetch/RichTextViewerWithFetch";
import { jsx as _jsx } from "react/jsx-runtime";
export const {
  RichTextViewerModalTID
} = getTestIds();
export default function RichTextViewerModal(_ref) {
  let {
    title,
    text,
    fetchText,
    onClose,
    queryKey
  } = _ref;
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    overflowContent: true,
    contentPadding: "small",
    width: "800px",
    height: "calc(100% - 128px)",
    title: title,
    onCloseButtonClick: onClose,
    "data-testid": RichTextViewerModalTID.Root(),
    content: /*#__PURE__*/_jsx("div", {
      "data-testid": RichTextViewerModalTID.Content(),
      style: {
        width: '100%',
        textAlign: 'left'
      },
      children: /*#__PURE__*/_jsx(RichTextViewerWithFetch, {
        queryKey: queryKey,
        text: text,
        fetchText: fetchText
      })
    })
  });
}